var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 1185 266","xmlns":"http://www.w3.org/2000/svg"}})}
var staticRenderFns = []

export { render, staticRenderFns }